import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../../components/table/table";
import { companiesCollection } from "../../../services/firebase";
import { CompanyTableStyled } from "./CompanyTable.styles";
import FilterComponent from "../../../components/filter/filter";
import { useGetCompaniesFiltersData } from "../../../components/filter/filter.utils";
import CompanyColumns from "./CompanyColumn";

function CompanyTable({ companies = [], searchQuery }) {
  const [filterState, setFilterState] = useState([
    {
      key: "type",
      value: "Client",
      color: "#FFDCAD",
      titleName: "Type",
    },
    {
      key: "companyState",
      value: "Active",
      color: "#BDB5F8",
      titleName: "State",
    },
  ]);
  const { options, isLoading: isFilterLoading } = useGetCompaniesFiltersData();
  const navigate = useNavigate();

  const filteredCompanies = useMemo(() => {
    // Group filters by key.
    const groupedFilters = filterState.reduce((acc, { key, value }) => {
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(value);
      return acc;
    }, {});

    // Filter companies:
    // For each filter key, check that the company's property is in the list of selected values.
    const filtered = companies.filter((company) => {
      return Object.entries(groupedFilters).every(([key, values]) => {
        // If "all" is selected for this key, ignore filtering by this key.
        if (values.includes("all")) return true;
        // Otherwise, the company property must be one of the selected values.
        return values.includes(company[key]);
      });
    });

    // Apply search query filtering.
    const query = searchQuery?.toLowerCase() || "";
    return filtered.filter((company) =>
      Object.values(company).some((value) =>
        value?.toString().toLowerCase().includes(query)
      )
    );
  }, [companies, filterState, searchQuery]);

  return (
    <CompanyTableStyled>
      <div className="company-table">
        <FilterComponent
          label="Filter Companies"
          options={options}
          state={filterState}
          setState={setFilterState}
          isLoading={isFilterLoading}
        />
        <div className="table-wrapper">
          <Table
            data={filteredCompanies}
            columns={CompanyColumns(navigate)}
            // isLoading={isLoading}
            noDataMessage={"No companies available"}
            sortable
            stickyHeader={true}
          />
        </div>
      </div>
    </CompanyTableStyled>
  );
}

export default CompanyTable;
